import HEADER from "@assets/HeaderImageCard.png";
import REVIEWS from "@assets/TrustPilotBanner.svg";
import BUY_ACCOUNT from "@assets/images/widgets/acheter-un-compte-lol-niveau-30.png";
import JOIN_DISCORD from "@assets/images/widgets/rejoindre-discord-secret-smurfs.png";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Icon from "@core-components/icon/Icon";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Card, Group, Image, Stack, Text } from "@mantine/core";

const Widgets: React.FC = () => {
  const { locationUrlBuilder } = useAppLanguage();
  const { t } = useAppTranslation("pages.blog.widgets");

  return (
    <Stack className="justify-center align-center">
      <Card
        withBorder
        className="p-7"
        classNames={{
          root: "bg-primary-darker border-primary-light background-image-[var(--image-url)] bg-center",
        }}
        padding="xs"
        radius="md"
        shadow="sm"
        styles={{
          root: {
            "--image-url": `url(${JOIN_DISCORD})`,
          } as React.CSSProperties,
        }}
      >
        <SSHeadline
          props={{
            stack: {
              align: "left",
            },
            title: {
              order: 3,
              ff: "unset",
            },
          }}
        >
          <Icon.Home className="pb-1.5" size={17} />
          &nbsp;
          <SSWhiteText>{t("discord.title")}</SSWhiteText>
        </SSHeadline>
        <Text
          classNames={{ root: "text-primary-light-text font-inter" }}
          my="md"
        >
          {t("discord.description")}
        </Text>

        <ButtonVariants.JoinDiscord className="hover-scale-small" />
      </Card>

      <Card
        withBorder
        className="py-7"
        classNames={{
          root: "hidden md:block bg-primary-darker border-primary-light background-image-[var(--image-url)] bg-bottom",
        }}
        padding="xs"
        radius="md"
        shadow="sm"
        styles={{
          root: {
            "--image-url": `url(${BUY_ACCOUNT})`,
          } as React.CSSProperties,
        }}
      >
        <SSHeadline
          props={{
            stack: {
              align: "center",
            },
            title: {
              order: 3,
              ff: "unset",
              className: "text-center",
            },
          }}
        >
          <Icon.GreenGift className="pb-1" size={17} />
          &nbsp;
          <SSWhiteText>{t("newAccount.title")}</SSWhiteText>
        </SSHeadline>
        <Stack align="center" maw={320} mx={"auto"}>
          <Text
            classNames={{
              root: "text-primary-light-text font-inter text-center px-[30px]",
            }}
            my="md"
          >
            {t("newAccount.description")}
          </Text>
          <Image src={HEADER} />

          <SSHeadline
            header={
              <Text className="text-left font-bold font-secret text-[16px] text-lg text-primary-dark-text">
                {t("newAccount.accountType")}
              </Text>
            }
            props={{
              stack: { align: "left" },
              title: {
                fz: 18,
              },
            }}
          >
            <SSWhiteText>{t("newAccount.accountTitle")}</SSWhiteText>
          </SSHeadline>
          <ButtonVariants.Gradient
            isFullWidth
            className="hover-scale h-12 rounded-xl"
            href={locationUrlBuilder(EPublicRoutes.SMURFS_NORMAL)}
            label={
              <Group justify="center">
                <Icon.AddToBasket size={20} />
                <Text className="font-bold text-[16px]">
                  {t("newAccount.buttonLabel")}
                </Text>
              </Group>
            }
          />
          <Image mah={60} maw={130} mx={"auto"} src={REVIEWS} />
        </Stack>
      </Card>
    </Stack>
  );
};

export default Widgets;
